<div class="chart-form box" [class.collapsed]="activation && !activation.value">
    <div class="box-header">
        <div *ngIf="!form.type" class="box-title">
            <mat-icon class="field-icon">{{ icon }}</mat-icon>
            {{ title | translate }}
        </div>

        <div *ngIf="form.type" [matMenuTriggerFor]="typeMenu" class="box-title" color="secondary">
            <mat-icon class="field-icon">{{ getTypeIcon(form.type) }}</mat-icon>

            <app-field-label [path]="form.name" [collection]="category" [label]="form.label"></app-field-label>
        </div>

        <mat-menu #typeMenu="matMenu">
            <ul class="type-select">
                <li (click)="setType('string')">
                    <mat-icon class="field-icon">title</mat-icon>
                    <span>{{ "editor.string" | translate }}</span>
                </li>

                <li (click)="setType('number')">
                    <mat-icon class="field-icon">format_list_numbered</mat-icon>
                    <span>{{ "editor.number" | translate }}</span>
                </li>

                <li (click)="setType('date')">
                    <mat-icon class="field-icon">date_range</mat-icon>
                    <span>{{ "editor.date" | translate }}</span>
                </li>

                <li (click)="setType('boolean')">
                    <mat-icon class="field-icon">tonality</mat-icon>
                    <span>{{ "editor.boolean" | translate }}</span>
                </li>
            </ul>
        </mat-menu>

        <lib-button *ngIf="field !== 'design' && form.name !== 'X Axis' && form.name !== 'Y Axis'" icon="delete"
            color="none" textColor="danger" (click)="removeFilter()">
        </lib-button>

        <!-- The "display" checkbox of a design section, as a switch: off folds the section -->
        <mat-slide-toggle *ngIf="activation" [checked]="!!activation.value" [attr.aria-label]="title | translate"
            (change)="activation.value = $event.checked; activation.update($event)">
        </mat-slide-toggle>
    </div>

    <div class="box-input" *ngIf="!activation || activation.value">
        <ng-container [ngTemplateOutlet]="inputList" [ngTemplateOutletContext]="{ inputs: bodyInputs() }">
        </ng-container>
    </div>
</div>

<!-- list -->
<ng-template #inputList let-inputs="inputs">
    <div *ngFor="let input of inputs" class="{{ input.block ? 'block' : '' }}" [ngClass]="{
      'column-100': ['checkbox', 'radio', 'textarea'].includes(input.type),
      'column-50': !['checkbox', 'radio', 'textarea'].includes(input.type)
    }">
        <!-- All inputs -->
        <ng-container [ngTemplateOutlet]="selectForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'select'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="textForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'text'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="numberForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'number'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="dateForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'datetime-local'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="checkboxForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'checkbox'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="radioForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'radio'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="colorsForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'colors'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="colorForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'color'">
        </ng-container>

        <ng-container [ngTemplateOutlet]="buttonForm" [ngTemplateOutletContext]="{ config: input }"
            *ngIf="input.type == 'button'">
        </ng-container>

        <lib-icon-picker *ngIf="input.type == 'icon'" [label]="input.label" [value]="input.value || null"
            (valueChange)="input.value = $event || ''; input.update({ target: { value: input.value } })">
        </lib-icon-picker>

        <mat-form-field *ngIf="input.type == 'textarea'" appearance="outline" subscriptSizing="dynamic" class="textarea-field">
            <mat-label>{{ input.label | translate }}</mat-label>
            <textarea matInput rows="2" [(ngModel)]="input.value" (change)="input.update($event)"></textarea>
        </mat-form-field>
    </div>
</ng-template>

<!-- select -->
<ng-template #selectForm let-config="config">
    <mat-form-field appearance="outline" [style.width]="config.width" subscriptSizing="dynamic">
        <mat-label>
            {{ config.label | translate }}
        </mat-label>

        <ng-container *ngIf="config.multiple">
            <mat-select [(ngModel)]="config.value" (selectionChange)="config.update($event)" size="5" multiple
                panelClass="auto-width-select-panel">
                <mat-select-trigger>
                    <ng-container *ngFor="let selectedValue of config.value; let last = last">
                        <ng-container *ngFor="let opt of config.options">
                            <span *ngIf="opt.value === selectedValue">
                                {{ opt.name | translate }}
                                <span *ngIf="!last">, </span>
                            </span>
                        </ng-container>
                    </ng-container>
                </mat-select-trigger>

                <mat-option [value]="opt.value" *ngFor="let opt of config.options">
                    <div class="select-option-content">
                        <mat-icon *ngIf="opt.icon" class="select-option-icon">{{ opt.icon }}</mat-icon>
                        <span>{{ opt.name | translate }}</span>
                    </div>
                </mat-option>
            </mat-select>
        </ng-container>

        <ng-container *ngIf="!config.multiple">
            <mat-select [(ngModel)]="config.value" (selectionChange)="config.update($event)"
                panelClass="auto-width-select-panel">
                <mat-select-trigger>
                    <ng-container *ngFor="let opt of config.options">
                        <span *ngIf="opt.value === config.value">
                            {{ opt.name | translate }}
                        </span>
                    </ng-container>
                </mat-select-trigger>

                <mat-option [value]="opt.value" *ngFor="let opt of config.options">
                    <div class="select-option-content">
                        <mat-icon *ngIf="opt.icon" class="select-option-icon">{{ opt.icon }}</mat-icon>
                        <span>{{ opt.name | translate }}</span>
                    </div>
                </mat-option>
            </mat-select>
        </ng-container>
    </mat-form-field>
</ng-template>

<!-- text -->
<ng-template #textForm let-config="config">
    <mat-form-field appearance="outline" class="" [style.width]="config.width" subscriptSizing="dynamic">
        <mat-label>
            {{ config.label | translate }}
        </mat-label>

        <input matInput type="text" [placeholder]="config.placeholder || 0" [(ngModel)]="config.value"
            (change)="config.update($event)" />
    </mat-form-field>
</ng-template>

<!-- number -->
<ng-template #numberForm let-config="config">
    <mat-form-field appearance="outline" class="" [style.width]="config.width" subscriptSizing="dynamic">
        <mat-label>
            {{ config.label | translate }}
        </mat-label>

        <input matInput type="number" placeholder="0" [(ngModel)]="config.value"
            [min]="config.min !== undefined ? config.min : null" [max]="config.max !== undefined ? config.max : null"
            (change)="config.update($event)" />
    </mat-form-field>
</ng-template>

<!-- date -->
<ng-template #dateForm let-config="config">
    <app-date-picker [label]="config.label | translate" [startDate]="getValidDate(config.value)"
        (dateChanged)="onDatePickerChange($event, config)">
    </app-date-picker>
</ng-template>

<!-- checkbox -->
<ng-template #checkboxForm let-config="config">
    <mat-checkbox [(ngModel)]="config.value" (change)="config.update($event)" [style.width]="config.width || '250px'">
        {{ config.label | translate }}
    </mat-checkbox>

    <div class="group box-input" *ngIf="config.groupKey && config.value">
        <ng-container [ngTemplateOutlet]="inputList" [ngTemplateOutletContext]="{ inputs: groups[config.group] }">
        </ng-container>
    </div>
</ng-template>

<!-- radio -->
<ng-template #radioForm let-config="config">
    <div [style.width]="config.width">
        <div class="input-label-group">
            <label style="display: block; width: 100%">
                {{ config.label | translate }}
            </label>

            <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="config.value"
                (change)="config.update($event)" [style.width]="config.width">
                <mat-radio-button class="radio-button" *ngFor="let opt of config.options" [value]="opt.value">
                    {{ opt.name | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="group box-input" *ngIf="config.groupKey && config.value">
            <ng-container [ngTemplateOutlet]="inputList" [ngTemplateOutletContext]="{
          inputs: groups[config.group + '_' + config.value]
        }">
            </ng-container>
        </div>
    </div>
</ng-template>

<!-- colors -->
<ng-template #colorsForm let-config="config">
    <div class="colors" [style.width]="config.width">
        <label style="display: block; width: 100%">
            {{ config.label | translate }}
        </label>

        <div class="color-container" [style.width]="config.width">
            <div class="color-item" *ngFor="let color of config.options; let index = index">
                <lib-color-picker [value]="color.value"
                    (valueChange)="color.value = $event; config.update({ target: { value: $event } }, index, 'color')">
                </lib-color-picker>

                <mat-form-field appearance="outline" class="" [style.width]="'200px'" subscriptSizing="dynamic">
                    <input matInput type="text" [(ngModel)]="color.label"
                        (change)="config.update($event, index, 'label')" />
                </mat-form-field>
            </div>
        </div>
    </div>
</ng-template>

<!-- color: "auto" (the theme color, an empty value) where the input allows it -->
<ng-template #colorForm let-config="config">
    <div class="color-item" [style.width]="config.width">
        <lib-color-picker [label]="config.label" [value]="config.value" [allowAuto]="!!config.auto"
            (valueChange)="config.value = $event; config.update({ target: { value: $event } })">
        </lib-color-picker>
    </div>
</ng-template>

<!-- button -->
<ng-template #buttonForm let-config="config">
    <div [style.width]="config.width">
        <button mat-flat-button color="primary" (click)="handleAction(config.action)">
            {{ config.label | translate }}
        </button>
    </div>
</ng-template>